import { Component, Input } from '@angular/core';
import { ISurvey } from '@maplix/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'maplix-social-share-widget',
  templateUrl: './social-share-widget.component.html',
  styleUrls: ['./social-share-widget.component.scss'],
})
export class SocialShareWidgetComponent {
  @Input()
  public entity: 'map' | 'survey';

  @Input()
  public title: string;

  constructor(private translate: TranslateService) {}

  public get facebook() {
    return 'https://www.facebook.com/sharer/sharer.php?u=' + location.href;
  }

  public get twitter() {
    return `https://twitter.com/intent/tweet?text=${this.translate.instant(this.entity + '.socials.BODY', {
      title: this.title,
    })} - ${location.href}`;
  }

  public get linkedin() {
    return 'https://www.linkedin.com/sharing/share-offsite/?url=' + location.href;
  }

  public get email() {
    return `mailto:?subject=${this.translate.instant(this.entity + '.socials.SUBJECT', {
      title: this.title,
    })}&body=${this.translate.instant(this.entity + '.socials.BODY', {
      title: this.title,
    })} - ${location.href}`;
  }
}
